var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollarMine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 89,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-4.4%",
    y: "-3.7%",
    width: "108.8%",
    height: "110.4%",
    filterUnits: "objectBoundingBox",
    id: "icon-dollar-mine_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0",
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-dollar-mine_svg__a)",
    transform: "translate(-115 -66)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 144c0 2.21-17.91 4-40 4-22.093 0-40-1.79-40-4s17.907-4 40-4c22.09 0 40 1.79 40 4",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 142h79",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.743 128.582c-1.578-1.614-3.737-2.582-6.057-2.582a8.398 8.398 0 00-5.262 1.867 8.902 8.902 0 00-3.063 4.814L146 142h17",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#C3F1E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36 131.704l1.897-7.507c1.387-5.412 6.32-9.197 11.978-9.197 2.774 0 5.364.91 7.443 2.47a12.054 12.054 0 014.421 6.386L193 141h-33l2.36-9.296z",
    stroke: "#076447",
    strokeWidth: 1.5,
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 130c0 1.101 1.119 2 2.5 2 1.379 0 2.5-.899 2.5-2 0-1.107-1.121-2-2.5-2-1.381 0-2.5-.896-2.5-2.001s1.119-1.999 2.5-1.999c1.379 0 2.5.894 2.5 1.999M176 124v-1M176 133v-1",
    stroke: "#076447",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#076447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.453 92.354l-27.51 33.981c-1.051 1.27-2.924 1.466-4.191.44a2.98 2.98 0 01-.44-4.192l27.51-33.982 4.631 3.753zM164.803 79.158c-.103.26-.247.495-.431.722l-1.9 2.338-.01.027c-1.22-1.227-2.97-2.608-4.42-3.589l.023-.016 1.886-2.348a2.883 2.883 0 014-.42c.94.746 1.323 2.088.852 3.286z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.742 92.61a2.326 2.326 0 001.73.534 2.319 2.319 0 001.585-.88l1.256-1.6a80.724 80.724 0 0113.589 16.937c.686 1.126 2.358.5 2.172-.812-1.273-9.023-5.428-17.644-12.363-24.292a31.815 31.815 0 00-2.227-2.014 36 36 0 00-2.382-1.815c-7.764-5.56-16.85-7.952-25.719-7.338-1.29.088-1.555 1.895-.323 2.333 6.604 2.42 12.985 5.796 18.96 10.113l-1.247 1.58a2.478 2.478 0 00.36 3.425l4.61 3.828z"
  })))));
}
export default SvgIconDollarMine;